<template>
    <div class="d-flex flex-column gap-4">
        <div class="d-flex gap-3">
            <AwesomeTab
                v-model="activeTabName"
                :label="$t('iFrame.info')"
                icon="info"
                name="info" />

            <AwesomeTab
                v-if="Array.isArray(event.faqs) && event.faqs.length"
                v-model="activeTabName"
                :label="$t('iFrame.faq')"
                icon="question"
                name="faq">
                <template #icon>
                    <font-awesome-icon
                        icon="question"
                        size="2x"
                        transform="shrink-8 up-1"
                        mask="comment" />
                </template>
            </AwesomeTab>

            <AwesomeTab
                v-if="Array.isArray(event.persons) && event.persons.length"
                v-model="activeTabName"
                :label="event.typeId === eventTypes.TYPE_SEMINAR ? $t('iFrame.speakers') : $t('iFrame.team')"
                icon="users"
                name="team" />
            <AwesomeTab
                v-if="event.location && event.location.latitude && event.location.longitude"
                v-model="activeTabName"
                :label="$t('iFrame.location')"
                icon="map-marker-alt"
                name="loc" />
        </div>
        <KeepAlive>
            <div>
                <EventEntryInfo
                    v-if="activeTabName === 'info'"
                    :event="event" />
                <EventEntryFaq
                    v-if="activeTabName === 'faq'"
                    :event="event" />
                <EventEntryTeam
                    v-if="activeTabName === 'team'"
                    :event="event" />
                <EventEntryLocation
                    v-if="activeTabName === 'loc'"
                    :event="event" />
            </div>
        </KeepAlive>
    </div>
</template>

<script>
import EventEntryInfo from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryInfo/EventEntryInfo";
import eventTypes from "@/util/consts/eventTypes";
import EventEntryFaq from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryFaq/EventEntryFaq";
import EventEntryTeam from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryTeam/EventEntryTeam";
import EventEntryLocation
    from "@/components/pages/eventIFrame/EventEntry/EventEntryDetails/EventEntryLocation/EventEntryLocation";

export default {
    name: "EventEntryDetails",
    components: {EventEntryTeam, EventEntryFaq, EventEntryInfo, EventEntryLocation},
    props: {
        event: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            activeTabName: "info",
            eventTypes
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .details-elements-grid {
    display: grid;
    column-gap: map-get($spacers, 5);
    row-gap: map-get($spacers, 4);
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
}
</style>
